































































































































































































import { Component, Prop, Vue } from 'vue-property-decorator'
import { TreeSelect } from 'ant-design-vue'
import DispatchApi from '@/api/dispatch'
import moment from 'moment'

@Component({})
export default class DispatchForm extends Vue {
	private addForm: any = {}
	private SHOW_PARENT = (TreeSelect as any).SHOW_PARENT
	private addLoading = false
	private initialRuleId = ''

	@Prop()
	private isAdd!: string

	private validateName(rule: any, value: string, callback: any) {
		let data: any = { ruleName: value }
		if (this.isUpdate) {
			data.id = this.initialRuleId
		}
		DispatchApi.checkUnique(data)
			.then((res: any) => {
				callback()
			})
			.catch((err: any) => callback(err.message))
	}

	private validateId(rule: any, value: string, callback: any) {
		let data: any = { ruleNo: value }
		if (this.isUpdate) {
			data.id = this.initialRuleId
		}
		DispatchApi.checkUnique(data)
			.then((res: any) => {
				callback()
			})
			.catch((err: any) => callback(err.message))
	}

	private get isUpdate() {
		return this.isAdd === '0'
	}

	private disabledDate(current: any) {
		return current && current < moment().startOf('day')
	}

	private cancel() {
		this.$multiTab.closeCurrentPage()
	}

	private getAreaInit(areas: any[]) {
		let temp = areas.map((item: any) => {
			if (item.countryCode) {
				return {
					label: item.countryName,
					value: item.countryCode,
				}
			} else if (item.cityCode) {
				return {
					label: item.cityName,
					value: item.cityCode,
				}
			} else {
				return {
					label: item.provinceName,
					value: item.provinceCode,
				}
			}
		})
		return temp
	}

	private formatAreas(areas: any) {
		return (
			areas &&
			areas.map((item: any) => {
				if (item.slice(-2) !== '00') {
					return {
						countryCode: item,
					}
				} else if (item.slice(2, 4) !== '00') {
					return {
						cityCode: item,
					}
				} else {
					return {
						provinceCode: item,
					}
				}
			})
		)
	}

	private onSubmit() {
		this.addLoading = true
		this.addForm.validateFields((errors: any, values: any) => {
			if (!errors) {
				values.effectStartTime = values.effectStartTime.format(
					'YYYY-MM-DD HH:mm'
				)

				values.partner = values.partner.map((item: any) => item.value)
				values.insurance = values.insurance.map((item: any) => item.value)
				values.area = this.formatAreas(
					values.area.map((item: any) => item.value)
				)

				if (this.isUpdate) {
					values.id = this.initialRuleId
					DispatchApi.updateRule(values)
						.then((res: any) => {
							this.$message.success(res.message || '修改成功')
							this.$multiTab.closeCurrentPage()
							this.$multiTab.open('/Settings/DispatchList')
						})
						.finally(() => {
							this.addLoading = false
						})
				} else {
					DispatchApi.createRule(values)
						.then((res: any) => {
							this.$message.success(res.message || '发布成功')
							this.$multiTab.closeCurrentPage()
							this.$multiTab.open('/Settings/DispatchList')
						})
						.finally(() => {
							this.addLoading = false
						})
				}
			} else {
				this.addLoading = false
			}
		})
	}

	private initPage() {
		if (this.isUpdate) {
			const initialRule = this.$ss.get('updateRule')
			const initialRuleId = initialRule && initialRule.id
			if (this.initialRuleId === initialRuleId) {
				return
			}
			this.initialRuleId = initialRuleId
			this.addForm.resetFields()
			this.addForm.setFieldsValue({
				ruleName: initialRule.ruleName,
				ruleNo: initialRule.ruleNo,
				ruleLevel: initialRule.ruleLevel,
				effectStartTime: moment(initialRule.effectStartTime),
				area: this.getAreaInit(initialRule.area),
				insurance: initialRule.insurance.map((item: any) => ({
					value: item.companyId,
					label: item.companyName,
				})),
				partner: initialRule.partner.map((item: any) => ({
					value: item.companyId,
					label: item.companyName,
				})),
			})
		}
	}

	private activated() {
		this.initPage()
	}

	private created() {
		this.addForm = this.$form.createForm(this)
		this.$store.dispatch('setting/initAreas')
		this.$store.dispatch('setting/initCompanyTree')
		this.$store.dispatch('setting/initPartnerTree')
	}
}
